<template>
  <div class="text-center">
    <b-spinner
      style="width: 5rem; height: 5rem;"
      variant="primary"
      label="Large Spinner"
    />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'Taobao2youLineCallback',

  components: { BSpinner },

  created() {
    this.callBack()
  },

  methods: {
    async callBack() {
      var status = false
      const queryString = window.location.search;
      var axios = require('axios');
      var config = {
        method: 'get',
        url: taobaoService_dotnet + 'LineNotify/callback' + queryString,
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        }
      };

      await axios(config)
      .then(function (response) {
        status = true
      })
      .catch(function (error) {
        console.log(error);
      });
      if (status == true) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'เชื่อมต่อรับการแจ้งเตือนผ่านทาง Line Notify สำเร็จ',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$router.push({path: '/connect'});
        // window.open('http://localhost:8080/connect',"_self");
      }
    }
  },
};
</script>